/* eslint-disable jsx-a11y/href-no-hash */
import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router';

import { mobileCheck } from '../../utils';

import './intro-template.scss';

class IntroTemplate extends PureComponent {
  state = {
    isMobile: mobileCheck(),
    style: {}
  };

  componentWillMount() {
    if (typeof window !== 'undefined' && !this.state.isMobile) {
      this.preloadVideo();
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.centerVideoBackground, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.centerVideoBackground, false);
  }

  preloadVideo = () => {
    fetch('/video.mp4')
      .then(resp => resp.blob())
      .then(data => {
        this.video.src = URL.createObjectURL(data);
      });
  };

  centerVideoBackground = () => {
    if (!this.layout) {
      return;
    }

    const { offsetWidth, offsetHeight } = this.layout;

    if (!offsetWidth || !offsetHeight || this.state.isMobile) {
      return;
    }

    const videoRatio = this.video.videoWidth / this.video.videoHeight;
    const layoutRatio = offsetWidth / offsetHeight;

    if (videoRatio > layoutRatio) {
      const width = Math.round(offsetHeight * videoRatio);

      const style = {
        top: 0,
        left: `${(offsetWidth - width) / 2}px`,
        height: `${offsetHeight}px`,
        width: `${width}px`,
        opacity: 1
      };

      this.setState({ style });
    } else {
      const height = Math.round(offsetWidth / videoRatio);

      const style = {
        top: `${(offsetHeight - height) / 2}px`,
        left: 0,
        width: `${offsetWidth}px`,
        height: `${height}px`,
        opacity: 1
      };

      this.setState({ style });
    }
  };

  render() {
    return (
      <div
        ref={elem => { this.layout = elem; }}
        className="intro"
      >
        <Helmet>
          <title>ЮниСервис Капитал</title>
        </Helmet>

        <div className="background-layer">
          {(!this.state.isMobile) &&
            <video
              autoPlay loop muted playsInline
              ref={elem => { this.video = elem; }}
              onLoadedData={this.centerVideoBackground}
              style={this.state.style}
            />
          }
        </div>

        <div className="container content-block">
          <div className="text-container">
            <h4>Добро пожаловать <br />в мир юнисервис капитал</h4>

            <h2>
              <span className="highlight"> Мир, в котором <br />всё иначе.</span> Всё не так, <br />как вы привыкли
            </h2>

            <h4>Узнайте наши правила и решите, <br />есть ли мир лучше этого</h4>

            <div className="btns-container">
              <Link to="/we/" className="btn btn-flex solid-white">
                <span>
                  <em>Начало<span className="icon">→</span></em>
                  Главные правила
                </span>
              </Link>
              <a
                className="disclosure_link"
                href="https://e-disclosure.ru/portal/company.aspx?id=37308"
                target="_blank" rel="noopener noreferrer">
                Адрес раскрытия информации <span className="icon">→</span>
              </a>
            </div>

          </div>
        </div>
      </div>

    );
  }
}

export default IntroTemplate;
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/components/Intro/IntroTemplate.js